import { render, staticRenderFns } from "./sbSelect.vue?vue&type=template&id=1f5aeb6a&scoped=true"
import script from "./sbSelect.vue?vue&type=script&lang=js"
export * from "./sbSelect.vue?vue&type=script&lang=js"
import style0 from "./sbSelect.vue?vue&type=style&index=0&id=1f5aeb6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5aeb6a",
  null
  
)

export default component.exports